import { Title } from 'react-head'
import { EditorProvider } from '../providers/Editor.provider'
import { DragNDropContextProvider } from '../providers/DragNDrop.provider'
import EditorWrapper from '../components/Editor/EditorWrapper'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useMemo } from 'react'
const EditorRoute = () => {
  const { tr } = useTr()

  const title = useMemo(() => {
    return tr(TrKey.editorRouteTitle) + ' | Atlascloud'
  }, [tr])

  return (
    <>
      <Title>{title}</Title>
      <EditorProvider>
        <DragNDropContextProvider>
          <EditorWrapper />
        </DragNDropContextProvider>
      </EditorProvider>
    </>
  )
}

export default EditorRoute
